



















import { defineComponent, ref, watch } from '@vue/composition-api';

const CommonHTMLEditor = defineComponent({
  props: {
    value: { default: () => '' },
    defaultValue: { default: () => '' },
    label: { default: () => '' },
  },
  setup(props, { emit }) {
    const _value = ref('');
    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal) _value.value = newVal;
    });

    return { _value };
  },
});

export default CommonHTMLEditor;
